export default `float de(vec3 p){
    float r = 1.;
    float height = 1.;

    float d = length(p.xz) - r;
    d = max(d, abs(p.y) - height);

    return d;
  }`